import clsx from 'clsx'
import React, { FC, MutableRefObject } from 'react'

import SvgAlert from '@Assets/SVG/Alert'
import { PageType } from '@Generated/graphql'
import { useCMSModalOpen } from '@Globals/CMS/Modal/Hook'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { Trans, useTranslation } from '@Globals/Translations'
import { Checkbox, CheckboxActionProps } from '@Shared/Components/Inputs/Checkbox/Checkbox'

import styles from './CheckoutTermsOfService.module.scss'

export interface CheckoutTermsOfServiceProps {
  actionRef?: MutableRefObject<CheckboxActionProps | null>
  checked: boolean
  onClick: (value: boolean) => void
}

export const CheckoutTermsOfService: FC<CheckoutTermsOfServiceProps> = ({ actionRef, checked, onClick }) => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')
  const { t } = useTranslation()
  const openModal = useCMSModalOpen()

  return (
    <div className={clsx(styles.checkoutTermsOfService, cofDesignV1 && styles.cofDesignV1)}>
      <Checkbox
        actionRef={actionRef}
        errorIcon={!cofDesignV1 && <SvgAlert className={styles.errorIcon} />}
        setInputValue={(v) => {
          onClick(v)
        }}
        validations={[value => ({ success: !!value, error: t('checkout:COD_YOU_NEED_TO_ACCEPT_TERMS') })]}
        value={checked}
      >
        <Trans
          components={{
            a: (
              <span
                className={styles.openTerms}
                // @ts-ignore
                href
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  openModal(PageType.Terms, '136')
                }}
                target
              />
            ),
          }}
          i18nKey="checkout:COF_TERMS_AND_CONDITIONS_TEXT"
          variables={{ arg1: '#' }}
        />
      </Checkbox>

    </div>
  )
}

